var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4375,
    width: 3.49723,
    height: 1.74862,
    transform: "rotate(45 11.4375 0)",
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40625 2.03125L11.8792 4.50417L4.41461 11.9687L1.23737 12.673L1.9417 9.4958L9.40625 2.03125Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/edit-pen-icon.a8aca03271c046bec1fb32da1bc824c4.svg";
export { ForwardRef as ReactComponent };